import { Analytics, logEvent } from "firebase/analytics";

function logEventAnalytics(
  event: { name: any; uid: any },
  analytics: Analytics
) {
  logEvent(analytics, event.name, { uid: event.uid });
}

export function removeConsecutivePunctuation(input: string) {
  // Replace consecutive punctuation with a single punctuation mark
  return input.replace(/([.,!?¡¿])\1+/g, "$1");
}

export const handleIntroQuestions = (
  text: string,
  analytics: any,
  currentUserId: { current: any }
) => {
  if (
    text.toLowerCase().includes("¿cómo describirías tu nivel actual de inglés?")
  ) {
    logEventAnalytics(
      { name: "level_question-1", uid: currentUserId.current },
      analytics
    );
  } else if (
    text
      .toLowerCase()
      .includes("¿cuánto tiempo has estado estudiando inglés?") ||
    text.toLowerCase().includes("cuánto tiempo has estado estudiando inglés")
  ) {
    logEventAnalytics(
      { name: "level_question-2", uid: currentUserId.current },
      analytics
    );
  } else if (
    text
      .toLowerCase()
      .includes(
        "¿cuáles han sido tus métodos favoritos para aprender inglés hasta ahora?"
      )
  ) {
    logEventAnalytics(
      { name: "level_question-3", uid: currentUserId.current },
      analytics
    );
  } else if (
    text.toLowerCase().includes("¿por qué quieres mejorar tu inglés?")
  ) {
    logEventAnalytics(
      { name: "level_question-4", uid: currentUserId.current },
      analytics
    );
  } else if (
    text
      .toLowerCase()
      .includes("¿cuál es tu objetivo específico para aprender inglés?") ||
    text
      .toLowerCase()
      .includes(
        "¿cuál es el objetivo específico que tienes en mente al aprender inglés"
      )
  ) {
    logEventAnalytics(
      { name: "level_question-5", uid: currentUserId.current },
      analytics
    );
  } else if (
    text
      .toLowerCase()
      .includes(
        "¿cuál es el mayor desafío que enfrentas al aprender inglés?"
      ) ||
    text
      .toLowerCase()
      .includes("¿qué te resulta más difícil al aprender inglés?") ||
    text
      .toLowerCase()
      .includes("qué te resulta más desafiante al aprender inglés")
  ) {
    logEventAnalytics(
      { name: "level_question-6", uid: currentUserId.current },
      analytics
    );
  }
};
